import { formatEthiopianDate, formatDualDate } from '../../utils/ethiopianCalendar';

/**
 * Drop-in replacement for date cells in react-table.
 * Usage:
 *   Cell: ({ value }) => <EthiopianDateCell value={value} />
 */
export const EthiopianDateCell = ({ value, dual = false, time = false }) => {
  if (!value) return <span className="text-muted">—</span>;
  return (
    <span title={new Date(value).toLocaleString()}>
      {dual
        ? formatDualDate(value, { includeTime: time })
        : formatEthiopianDate(value, { includeTime: time })
      }
    </span>
  );
};